import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AlertListRequest,
  AlertListTableItem,
  AlertStats,
  CompAlertStatus,
} from '@/api';
import { ComplianceAlertsData, ComplianceAlertStatsData } from '../models';

export interface ComplianceAlertStatsSliceState {
  data: ComplianceAlertStatsData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceAlertStatsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceAlertStatsSlice = createSlice({
  name: 'complianceAlertStats',
  initialState,
  reducers: {
    setStats: (state, action: PayloadAction<AlertStats>) => {
      state.data = {
        alerts: { ...(state?.data?.alerts || { entries: [], total: 0 }) },
        stats: { ...action.payload },
      };
    },
    setList: (state, action: PayloadAction<ComplianceAlertsData>) => {
      state.data = {
        alerts: {
          entries: [...(action?.payload?.entries || [])],
          total: action.payload?.total || 0,
        },
        stats: { ...(state.data?.stats || ({} as AlertStats)) },
      };
    },
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchAlertStats: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
    fetchAlertList: (state, action: PayloadAction<AlertListRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    refreshAlertStatus: (
      state,
      action: PayloadAction<{ id: string; status: CompAlertStatus }>,
    ) => {
      if (state.data?.alerts?.entries) {
        const currentItems: AlertListTableItem[] = JSON.parse(
          JSON.stringify(state.data.alerts.entries || []),
        );
        const newItems = [...currentItems];

        if (action.payload) {
          const itemIndex = currentItems.findIndex(
            (item) => item.id === action.payload.id,
          );

          if (itemIndex !== -1) {
            const item = currentItems[itemIndex];
            item.state = action.payload.status;
            newItems.splice(itemIndex, 1, item);
          }
        }

        state.data.alerts.entries = newItems;
      }
    },
  },
});

export { complianceAlertStatsSlice };
